//
// ExportDataEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "./ExportDataController";
import "@sas-dvr/ltjs-commons/resources/network/URL";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";

var ExportDataEvent = createModule("BIRD::ExportDataEvent", ["commons::PortableEvent"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getExportDataController: [1],
        getWarnings: [[1]],
        getExportURL: [1],
    },
    ,
    ,
]);
export default ExportDataEvent;
